import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import ForgottenPw from './ForgottenPw';

const ForgottenPwMutation = gql`
  mutation forgottenPw($email: String!, $language: String!, $countryCode: String!) {
    forgottenPw(email: $email, language: $language, countryCode: $countryCode)
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

export default compose(
  graphql<IInputProps, IResponse>(ForgottenPwMutation, {
    name: 'forgottenPw'
  })
)(ForgottenPw);



// WEBPACK FOOTER //
// ./src/components/Query/User/ForgottenPw/index.tsx